<template>
  <div>
    <div class="title-div">燃气户号管理-添加</div>
    <div class="form-div">

      <el-form :model="form" :rules="rules" hide-required-asterisk label-position="top" label-width="80px" ref="form">
        <el-form-item label="当前手机号:">
          <el-input v-model="form.telephone" :disabled="disableTelephone"></el-input>
        </el-form-item>

        <keep-alive>
          <el-form-item label="用户编号:" prop="userNumber" :required="true">
            <el-input v-model="form.userNumber" :disabled="disableUserNumber"></el-input>
          </el-form-item>
        </keep-alive>

        <el-form-item label="详细地址:" prop="detailedAddress" :required="true"  style="width: 180%">
          <el-input  type="textarea" autosize v-model="form.detailedAddress"
                     style="width: 55%" :disabled="disableAddress"></el-input>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;若信息有误，您可以</span>
          <el-link  @click="changeAddress" :underline="false">申报更正地址</el-link>
        </el-form-item>

        <el-form-item label="联系人:" prop="contact" :required="true">
          <el-input v-model="form.contact" :disabled="disableContact"></el-input>
        </el-form-item>

        <el-form-item label="标签:" prop="label" :required="true">
          <el-input v-model="form.label" ></el-input>
        </el-form-item>




        <el-form-item>
          <el-button @click="onSubmit" class="submit-button" type="primary" :loading="loading">提交</el-button>
        </el-form-item>
      </el-form>



    </div>

  </div>

</template>

<script>
  import { newConfirmBindUserGas } from '../../../api/accountNumberManagement'
  import { getUserInfo } from '../../../api/login'
  export default {
    name: 'GasAccountManagement2',
    data () {
      var validatorPhone = function (rule, value, callback) {
        let rules = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
        if (!rules.test(value)) {
          callback(new Error('手机号格式错误'))
        } else {
          callback()
        }
      }
      return {
        form:{
          telephone: '', // 当前手机号
          userNumber: '', // 用户编号
          detailedAddress: '', // 详细地址
          contact: '', // 联系人
          label:''  //标签
        },

        meterType: '', // 表型
        timer: null,
        label: '', // 标签

        //手机号输入框是否禁用
        disableTelephone:true,
        //用户编号输入框是否禁用
        disableUserNumber:true,
        //详细地址输入框是否禁用
        disableAddress:true,
        //联系人输入框是否禁用
        disableContact:true,
        //按钮加载
        loading:false,



        rules: {
          telephone:[
            { required: true, message: '请输入您的手机号', trigger: 'blur' },
            { required: true, validator: validatorPhone, trigger: 'blur' },
          ],
          userNumber: [
            { required: true, message: '请输入用户编号', trigger: 'blur' }
          ],
          detailedAddress:[
            { required: true, message: '请输入详细地址', trigger: 'blur' }
          ],
          contact:[
            { required: true, message: '请输入联系人', trigger: 'blur' }
          ],
          label:[
            { required: true, message: '请输入标签', trigger: 'blur' }
          ]
        }
      }
    },

    mounted () {
      this.form.telephone = JSON.parse(window.localStorage.userInfo).mobile
      this.form.userNumber = this.$route.query.number
      this.form.detailedAddress = this.$route.query.data
      this.form.contact = JSON.parse(window.localStorage.userInfo).contacts ? JSON.parse(window.localStorage.userInfo).contacts : ''

      this.meterType = this.$route.query.meterType

      this.disableTelephone = !this.form.telephone == '';
      this.disableUserNumber = !this.form.userNumber == '';
      this.disableAddress = !this.form.detailedAddress == '';
      this.disableContact = !this.form.contact == '';
    },
    methods: {

      // 提交
      onSubmit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            const that = this;
            that.loading = true;
            const params = {
              userId: JSON.parse(window.localStorage.userInfo).id,
              userCode: that.form.userNumber,
              contacts: that.form.contact,
              label: that.form.label,
              meterType: that.$route.query.meterType,
              address: that.form.detailedAddress
            }

            newConfirmBindUserGas(params).then(res => {
              if (res.data.success) {
                that.loading = false;
                that.getInfo()
                that.$message.success(res.data.message)
                // 清除延迟执行
                clearTimeout(that.timer)
                // 设置延迟执行,这里设置延迟两秒执行
                that.timer = setTimeout(() => {
                  that.$router.go(-2)
                }, 2000)
              } else {
                that.loading = false;
                that.$message.error(res.data.message)
              }
            }).catch(() => {
              that.loading = false;
              that.$message.error('绑定燃气号失败')
            })

          } else {

            return false
          }
        })
      },


      //申报更正地址
      changeAddress(){
        this.$router.push({
          name: 'PCGasAccountManagement3',
          query: {
            userNumber: this.form.userNumber,
            detailedAddress: this.form.detailedAddress
          }
        })
      },

      // 根据userId获取用户信息
      getInfo () {
        const params = JSON.parse(window.localStorage.userInfo).id
        getUserInfo(params).then(res => {
          if (res.data.success) {
            window.localStorage.userInfo = JSON.stringify(res.data.rows[0])
          }
        }).catch(() => {
        })
      }

    },
  }
</script>

<style scoped>

  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .form-div {
    padding: 47px 40% 57px 40%;
  }

  .submit-button {
    width: 100%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .submit-button {
    width: 100%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }
  /deep/.el-link.el-link--default{
    color: #BD1A2D;
  }

  /deep/.el-link.el-link--default:hover {
    color: #BD1A2D;
  }


  /deep/ .el-form--label-top .el-form-item__label {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .el-button.is-plain:focus, .el-button.is-plain:hover {
    background: #FFF;
    border-color: #BD1A2D;
    color: #BD1A2D;
  }

  /deep/.el-loading-spinner .path{
    stroke:#BD1A2D;
  }

</style>
